import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function UsersAPI(): BringozApi {
  return {
    base: `/users`,
    infiniteScroll: {
      address: `/users`,
      cmd: 'GET'
    },
    actions: {
      changePassword: {
        address: 'password',
        cmd: 'POST',
        updateable : true
      }
    }
  }
}
angular
  .module('bringoz.admin.user')
  .factory('UsersAPI', UsersAPI);
